import { useState, useEffect } from 'react';
import { doc, getDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';
import { useAuth } from '../contexts/AuthContext';

export const useUserAccess = () => {
  const { currentUser } = useAuth();
  const [userAccess, setUserAccess] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser?.email) {
      setUserAccess(null);
      setLoading(false);
      return;
    }

    // Listen to user access changes in real-time
    const userAccessRef = doc(db, 'userAccess', currentUser.email);
    const unsubscribe = onSnapshot(userAccessRef, (doc) => {
      if (doc.exists()) {
        const accessData = doc.data();
        setUserAccess(accessData);
      } else {
        // No access record found - user hasn't purchased anything
        setUserAccess({
          hasAccess: false,
          storyTokens: 0,
          tokensUsed: 0
        });
      }
      setLoading(false);
    }, (error) => {
      console.error('Error fetching user access:', error);
      setUserAccess({
        hasAccess: false,
        storyTokens: 0,
        tokensUsed: 0
      });
      setLoading(false);
    });

    return unsubscribe;
  }, [currentUser?.email]);

  const canCreateStory = () => {
    if (!userAccess) return false;
    return userAccess.storyTokens > userAccess.tokensUsed;
  };

  const remainingTokens = () => {
    if (!userAccess) return 0;
    return Math.max(0, userAccess.storyTokens - userAccess.tokensUsed);
  };

  return {
    userAccess,
    loading,
    canCreateStory: canCreateStory(),
    remainingTokens: remainingTokens(),
    hasAccess: userAccess?.hasAccess || false
  };
};
